import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class IncompleteProcessReportCriteria extends ValueObject  
{
}